import { ReactNode } from 'react';

import clsx from 'clsx';
import { match } from 'ts-pattern';

import { Link } from './Link';

interface CardProps {
  children: ReactNode;
  className?: string;
  href?: string;
  clickable?: boolean;
  elevated?: boolean;
}

export const Card: React.FC<CardProps> = ({
  className,
  href,
  children,
  clickable,
  elevated,
}) => {
  const cardClass = clsx(
    'flex flex-1 items-start justify-start rounded-lg overflow-hidden',
    clickable && 'hover:shadow-lg active:bg-neutral-50',
    elevated && 'shadow',
    className,
  );

  return match(!!href)
    .with(true, () => (
      <Link href={href} className={cardClass}>
        {children}
      </Link>
    ))
    .with(false, () => <div className={cardClass}>{children}</div>)
    .exhaustive();
};
